import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroManualJournalRequestForm', {
    headerText: 'Manual Journal details',
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    debitCreditError: 'Debit and Credit amounts are not equal.',
});
